import AsciiPage from './pages/AsciiPage/AsciiPage';

function App() {
    return <AsciiPage />;
}

export default App;
